export default "__VITE_ASSET__Brzckt1P__"